import { useEffect, useRef, useState } from "react";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

const KEY = "beatflow_caption";
const local = () => { try { return localStorage.getItem(KEY) || ""; } catch (e) { return ""; } };

export const readCaption = (user) => (user && typeof user.clip_caption === "string" ? user.clip_caption : local());

export function useCaption() {
  const { user, setUser } = useAuth();
  const [caption, setCaption] = useState(() => readCaption(user));
  const timer = useRef(null);
  const syncedId = useRef(user ? user.id : null);

  useEffect(() => {
    const id = user ? user.id : null;
    if (id === syncedId.current) return;
    syncedId.current = id;
    if (user && typeof user.clip_caption === "string") setCaption(user.clip_caption);
  }, [user]);
  useEffect(() => () => clearTimeout(timer.current), []);

  const change = (v) => {
    const val = v.slice(0, 60);
    setCaption(val);
    try { localStorage.setItem(KEY, val); } catch (e) { /* noop */ }
    if (!user) return;
    clearTimeout(timer.current);
    timer.current = setTimeout(() => {
      api.put("/me/caption", { caption: val })
        .then(() => setUser((u) => (u ? { ...u, clip_caption: val } : u)))
        .catch(() => {});
    }, 700);
  };

  return [caption, change];
}
